<template>
  <div class="text-left px-6 pb-12 bg-gray-50 h-screen relative">
    <div class="absolute mt-11" @click="back">
      <back-arrow-icon :width="'w-4'" :height="'h-4'"></back-arrow-icon>
    </div>
    <div class="text-center text-sm font-extrabold w-full pt-12">CURRENT DELIVERIES</div>
    <no-orders></no-orders>
    <current-orders></current-orders>
  </div>
</template>

<script>
import BackArrowIcon from '@/components/icons/BackArrowIcon.vue'
import NoOrders from '../components/CurrentDeliveries/NoOrders.vue'
import CurrentOrders from '../components/CurrentDeliveries/CurrentOrders.vue'

export default {
  components: {
    BackArrowIcon,
    NoOrders,
    CurrentOrders
  },
  data() {
    return {
      promo_code: '',
      payment_type: {
        pick_up: false,
        delivery: false,
        card: false
      }
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'Dashboard'
      })
    }
  },
  mounted() {
    this.$store.dispatch('middleware/isLoggedIn')
  }
}
</script>

<style></style>
